// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"644fd318","253":"114325fb","263":"3cb9c031","349":"1dd8b627","404":"6ec9aaa9","498":"b2ece191","513":"62978eae","739":"328d40db","994":"08117d9f"}[chunkId] + ".chunk.js";
};